import type { AuctionCarTransaction, AuctionsChartPayload } from "@/types/auctions";
import type { PaginatedList } from "@/types/entity";

type ApiTransactionRecord = AuctionCarTransaction & {
  is_outlier?: boolean;
  is_replica?: boolean;
  location_region?: string;
  event_region?: string;
  hammer_price_original?: number;
  listing_price_original?: number;
  original_price?: number;
  currency?: string;
};

type ApiHistoryRecord = AuctionsChartPayload & {
  is_outlier?: boolean;
  is_replica?: boolean;
};

export function normalizeTransactionRecord(record: ApiTransactionRecord): AuctionCarTransaction {
  return {
    ...record,
    outlier: record.outlier ?? record.is_outlier ?? false,
    replica: record.replica ?? record.is_replica ?? false,
    event_region: record.event_region ?? record.location_region,
    original_currency: record.original_currency ?? record.currency,
  };
}

export function normalizeTransactionsList(
  response: PaginatedList<ApiTransactionRecord>
): PaginatedList<AuctionCarTransaction> {
  return {
    ...response,
    results: response.results.map(normalizeTransactionRecord),
  };
}

export function normalizeHistoryRecord(record: ApiHistoryRecord): AuctionsChartPayload {
  return {
    ...record,
    outlier: record.outlier ?? record.is_outlier ?? false,
    replica: record.replica ?? record.is_replica ?? false,
  };
}

export function normalizeHistoryList(records: ApiHistoryRecord[]): AuctionsChartPayload[] {
  return records.map(normalizeHistoryRecord);
}
